"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const ChevronUp = (props) => {
    const { width = '32px', height = '32px' } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 32 32" },
        react_1.default.createElement(react_native_svg_1.Path, { d: "m22 19-6-6-6 6", stroke: "#404040", fill: "none", "fill-rule": "evenodd" })));
};
exports.default = react_1.default.memo(ChevronUp);
